import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWolframlanguageComponent } from './simple-icons-wolframlanguage.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWolframlanguageComponent ],
    exports:      [ SimpleIconsWolframlanguageComponent ],
    bootstrap:    []
})
export class SimpleIconsWolframlanguageModule {}
